var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1128,
    height: 552,
    viewBox: "0 0 1128 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1128,
    height: 552,
    fill: "#E1EBF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 96,
    width: 240,
    height: 360,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 96,
    width: 240,
    height: 270,
    fill: "#0A2832"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 639,
    y: 96,
    width: 240,
    height: 180,
    fill: "#058C50"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 639,
    y: 276,
    width: 240,
    height: 90,
    fill: "#FF5F28"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 639,
    y: 366,
    width: 240,
    height: 90,
    fill: "#058CD7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 969,
    y: 96,
    width: 180,
    height: 90,
    transform: "rotate(90 969 96)",
    fill: "#FFBE14"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 969,
    y: 276,
    width: 180,
    height: 90,
    transform: "rotate(90 969 276)",
    fill: "#FFA5C3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 366,
    width: 240,
    height: 90,
    fill: "#AFBEC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorInterface);
export default __webpack_public_path__ + "static/media/color-interface.1fe141b595e9153e0a233396c62ba272.svg";
export { ForwardRef as ReactComponent };